// Vendors
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
// Utilities
import { cancelOnboardingProcessService } from '../services/cancel-drop-modal-footer.service';

const cancelOnboardingProcessResolver = async (): Promise<[true] | [null, true]> => {
  const [, { status }] = await cancelOnboardingProcessService();

  return requestHasSuccessStatus(status) ? [true] : [null, true];
};

export { cancelOnboardingProcessResolver };
